/**
 * Two pure helpers the chat picker needs.
 *
 * A chat is a real destination when it is enabled and is not an unaccepted
 * message request. `postPolicy` is not on `/chat/list-mine`, so an
 * officers-only chat cannot be filtered here and surfaces as
 * ANNOUNCEMENTS_ONLY after the tap.
 */

export type typeShareableChat = {
  chatId: string;
  title: string;
  lastMessagePreview: string | null;
};

export function selectShareableChats(
  items: readonly {
    chatId: string;
    title: string;
    lastMessagePreview?: string | null;
    isEnabled: boolean;
    isPendingApproval: boolean;
  }[],
): typeShareableChat[] {
  return items
    .filter((item) => item.isEnabled && !item.isPendingApproval)
    .map((item) => ({
      chatId: item.chatId,
      title: item.title,
      lastMessagePreview: item.lastMessagePreview ?? null,
    }));
}

/** A fresh idempotency key per share. Two shares are never one message. */
export function buildShareRequestId(): string {
  return crypto.randomUUID();
}

/** The confirmation line after a share. Same words as the mobile sheet (ISSUE-175). */
export function buildShareSentBody(chatTitle: string): string {
  return `Your game card is in ${chatTitle}.`;
}
